<!-- Revised on 2024/12/11 by mnavarro -->
<template>
    <div class="pb-0 card-header">
        <div class="d-lg-flex">
            <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
            </div>
            <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Edit actions (Add, clone and edit) -->
                    
                    <!-- Activate and deactivate actions -->
                    
                    <!-- Recover and delete actions -->
                    
                    <!-- Interactions with database (filters and reload) -->
                    <ReloadButton id="reload" :title="$t('key_warehouseListTableHeader_button_reload_warehouse')" :enable-reload="enableReload" @reload-page="reloadPage"/>
                </div>
            </div>
            <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Search space -->
                    <Searchbox :enable-search="enableSearch" :list-filters="listFilters" @search-change="searchChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ReloadButton from "./../../../../generic_components/ReloadButton.vue";
    import Searchbox from "./../../../../generic_components/Searchbox.vue";

    export default {
        name: "WarehouseListTableHeader",
        components: {
            ReloadButton,
            Searchbox
        },
        props: {
            title: {
                type: String,
                default: ""
            },
            description: {
                type: String,
                default: ""
            },
            enableReload: {
                type: Boolean,
                default: true
            },
            enableSearch: {
                type: Boolean,
                default: true
            },
            selectedIds: {
                type: Array,
                default: () => []
            },
            listFilters: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['search-change', 'reload-page'],
        methods: {
            reloadPage() {
                this.$emit("reload-page");
            },
            searchChange(searchValue) {
                this.$emit("search-change", searchValue);
            }
        }
    }

</script>